// (c) Copyright 2024-2025 Hewlett Packard Enterprise Development LP
import { StrictMode } from "react"
import { createRoot } from "react-dom/client"
import { mountVercelToolbar } from "@vercel/toolbar"
import { App } from "./App"
import { flagManager } from "./flag-manager"
import { initShell } from "./init"
import i18n from "./i18n-config/i18n"
import "./index.css"
import { env, extractOrigin } from "./utils/env"

async function bootstrapMirage() {
  try {
    const { createMockServerForCypress, createMockServerForDev } = await import(
      "./mirage/mock-server"
    )
    if (window.Cypress) {
      createMockServerForCypress()
    } else {
      createMockServerForDev()
    }
  } catch (err) {
    console.error(err)
  }
}

function initGlpHeader() {
  const headerNode = document.querySelector("greenlake-header")
  if (!headerNode) {
    return
  }
  headerNode.platform = "publicDefault"
  headerNode.language = i18n.language
  headerNode.linkbaseurl = extractOrigin(env.REACT_APP_CCS_LOGIN)
}

;(async () => {
  if (env.REACT_APP_PROXY_MIRAGE === "true") {
    await bootstrapMirage()
  }

  // REACT_APP_VERCEL_ENV is a system environment variable injected by Vercel
  // https://vercel.com/docs/projects/environment-variables/framework-environment-variables#REACT_APP_VERCEL_ENV
  if (process.env.REACT_APP_VERCEL_ENV) {
    console.log(
      "[ConsoleShell] Vercel environment.",
      process.env.REACT_APP_VERCEL_ENV
    )
    mountVercelToolbar()
  }

  // initialize Launchdarkly client and fetch anonymous flags
  const fm = await flagManager.init()
  initShell({ flagClient: fm, window })
  initGlpHeader()

  const root = createRoot(document.getElementById("root"))
  root.render(
    <StrictMode>
      <App ldClient={fm.client} />
    </StrictMode>
  )
})()
